import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import DotDotDot from '../../../app/components/dotdotdot';
import styles from './post-title.scss';

export const PostTitle = ({ titleElementType, title, type, lineCount }) => {
  const titleClassName = classNames(
    styles.title,
    styles[type],
    'post-title',
    'post-title__text',
    'blog-post-title-color',
    'blog-hover-container-element-color',
  );

  const renderChildren = () => (
    <DotDotDot useExactLineHeight={true} clamp={lineCount}>
      {title}
    </DotDotDot>
  );

  return React.createElement(
    titleElementType,
    {
      className: titleClassName,
      dataHook: 'post-title',
    },
    renderChildren(),
  );
};

PostTitle.propTypes = {
  titleElementType: PropTypes.string,
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  lineCount: PropTypes.number,
};

PostTitle.defaultProps = {
  titleElementType: 'h2',
};

export default PostTitle;
